import React from 'react';
import { useTranslation } from 'react-i18next';

import { LegacyFieldReadMode } from '~/legacy-components/LegacyForms';

import { Country, EmpOtherContactType } from '../../data';

type Props = {
  data: EmpOtherContactType;
  countryList: Country[];
};

export const OtherContactReadMode = ({ data: emp, countryList }: Props) => {
  const { t } = useTranslation();
  const nationality = countryList?.find(
    (country) => country.code === emp?.fEmpCountry,
  );
  return (
    <>
      <LegacyFieldReadMode
        label={t('fEmpPhoneHome')}
        value={emp?.fEmpPhoneOther}
      />
      <LegacyFieldReadMode
        label={t('fEmpEmailHome')}
        value={emp?.fEmpEmailOther}
      />
      <LegacyFieldReadMode
        label={t('fEmpStreetAddress1')}
        value={emp?.fEmpStreetAddress1}
      />
      <LegacyFieldReadMode
        label={t('fEmpStreetAddress2')}
        value={emp?.fEmpStreetAddress2}
      />
      <LegacyFieldReadMode
        label={t('fEmpPostalCode')}
        value={emp?.fEmpPostalCode}
      />
      <LegacyFieldReadMode label={t('fEmpCity')} value={emp?.fEmpCity} />
      <LegacyFieldReadMode label={t('fEmpState')} value={emp?.fEmpState} />
      <LegacyFieldReadMode label={t('fEmpCountry')} value={nationality?.name} />
    </>
  );
};
